//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { PaymentSourceType } from './Enums';

export class SurchargeResultItem extends ItemBase {
    Surcharge: number = 0;
    Total: number = 0;
    PaymentSourceType: PaymentSourceType = PaymentSourceType.BankAccount;

    constructor(initializer?: Partial<SurchargeResultItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SurchargeResultItem";
}
